import React, { useEffect, useState } from 'react';

import Paginator from '../../elements/paginator';
import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';
import TableHead from 'crm/elements/common/TableHead';

function PrizesList({ prizesFirstPage, prizesCount, url }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [prizes, setPrizes] = useState([]);

    const getPrizes = (page = 1) => {
        let requestUrl = url;
        if (page !== 1) {
            requestUrl += `?page=${page}`;
        }
        axios.get(requestUrl).then((response) => {
            setPrizes(response.data.data);
            setCurrentPage(response.data.current_page);
            setLastPage(response.data.last_page);
        });
    };

    /**
     * first page may come with object
     * and this is why calculation
     * of last page is needed
     */
    useEffect(() => {
        if (prizesFirstPage == null || prizesCount == null) {
            getPrizes();
            return;
        }
        if (prizesCount > 0) {
            const pages = prizesCount / prizesFirstPage.length;
            setLastPage(pages % 1 === 0 ? pages : Math.ceil(pages));
        }
        setPrizes(prizesFirstPage);
    }, [prizesFirstPage, prizesCount]);

    function getPrizesList() {
        return prizes.map(({ id, lines_won_count, total_formatted, per_user_formatted }) => (
            <tr key={id}>
                <td>{lines_won_count}</td>
                <td>{total_formatted}</td>
                <td>{per_user_formatted}</td>
            </tr>
        ));
    }
    return (
        <Card title="Prizes">
            <div className="table-responsive">
                <table className="table model-list">
                    <TableHead>
                        <th>Lines won</th>
                        <th>Total</th>
                        <th>Per user</th>
                    </TableHead>
                    <tbody>{getPrizesList()}</tbody>
                </table>
                <Paginator currentPage={currentPage} lastPage={lastPage} onPageChange={getPrizes} />
            </div>
        </Card>
    );
}

export default PrizesList;
